import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl, mobile_xs } from '../../global/mediaQueryMixin';

interface Props {
  isBlackText?: boolean;
  isListHeader?: boolean;
}

const Group = styled.div`
  width: 100%;
  max-width: 1022px;
  height: 100vh;
  margin: auto;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

const Container = styled.div`
  background-color: var(--background-secondary);
`;

const HeaderBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 14px 0 24px;
`;

const Heading = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .close-icon {
    cursor: pointer;
    path {
      stroke: var(--text-primary);
    }
    :hover {
      background-color: var(--neutral-secondary);
      border-radius: var(--border-radius-4);
    }
  }
  .more-icon {
    cursor: pointer;
    fill: var(--text-secondary);
    stroke: var(--text-secondary);
    :hover {
      background-color: var(--background-muted);
      border-radius: var(--border-radius-4);
    }
  }
  .customer-icon {
    width: 28px;
    height: 28px;
    path {
      fill: var(--brand-primary);
    }
  }
  ${mobile_xl(css`
    .customer-icon {
      width: 24px;
      height: 24px;
    }
  `)}
`;

const Title = styled.h1`
  ${Typography.heading_lg}
  color: var(--text-primary);
  margin: 0;
`;

const Content = styled.div`
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  overflow: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  ${mobile_xl(css`
    margin-top: 8px;
  `)}
`;

const TitleWrap = styled.h2`
  width: 100%;
  max-width: 510px;
  ${Typography.body_md_medium}
  text-transform: uppercase;
  color: var(--text-primary);
  margin: 0;
`;

const OptionMenu = styled.div<Props>`
  position: relative;
  ${mobile_xl(css`
    position: sticky;
    right: 0;
    padding: 20px 12px;
    background-color: var(--background-primary);
    display: flex;
    align-items: center;
    box-shadow: -1px 0px 8px 0px rgba(0, 0, 0, 0.04);

    ${(props: Props) =>
      props.isListHeader &&
      css`
        height: 45px;
        padding: 0 12px;
      `}
  `)}
`;

const TableData = styled.div<Props>`
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 12px 12px 11px;
  background-color: var(--background-primary);
  border-top: 0.5px solid var(--border-primary);
  .active {
    background-color: var(--background-muted);
    border-radius: var(--border-radius-4);
  }
  cursor: pointer;
  :hover {
    background-color: var(--neutral-secondary);
  }
  ${(props: Props) =>
    props.isListHeader &&
    css`
      border-top: none;
      background-color: var(--background-tertiary);
      :hover {
        background-color: var(--background-tertiary);
      }
    `}
  ${mobile_xl(css`
    width: max-content;
    padding: 0;
    ${(props: Props) =>
      props.isListHeader &&
      css`
        /* gap: 12px; */
      `}
  `)}
`;

const UserDetails = styled.div`
  width: 100%;
  max-width: 535px;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Username = styled.h5<Props>`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: 0;
  ${(props: Props) =>
    props.isBlackText &&
    css`
      color: var(--text-primary);
    `}
`;

const UserDescription = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: 0;
`;

const UserMail = styled.p<Props>`
  width: 100%;
  max-width: 262px;
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: 0;
  min-width: 150px;
  margin-right: 12px;
  ${(props: Props) =>
    props.isListHeader &&
    css`
      padding-left: 12px;
      margin-right: 0;
      border-left: 0.5px solid var(--border-primary);
    `}
  ${mobile_xl(css`
    border-left: 1px solid transparent;
    padding-left: 12px;
    margin-right: 13px;
    min-width: 262px;
    ${(props: Props) =>
      props.isListHeader &&
      css`
        padding-left: 12px;
        margin-right: 0;
        border-left: 0.5px solid var(--border-primary);
      `};
  `)}
`;

const UserNumber = styled.p<Props>`
  width: 100%;
  max-width: 106px;
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: 0;
  white-space: nowrap;
  min-width: 106px;
  ${(props: Props) =>
    props.isListHeader &&
    css`
      border-left: 0.5px solid var(--border-primary);
      padding-left: 12px;
    `}
`;

const Modalhead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 0.5px solid var(--border-primary);
`;

const Headline = styled.h6`
  ${Typography.body_lg_semibold}
  color: var(--text-primary);
  margin: 0;
`;

const Empty = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: calc(50% + 110px);
  transform: translate(-50%, -50%);
  ${mobile_xl(css`
    left: 50%;
  `)}
`;

const ProfileIcon = styled.div`
  padding: 0 4px 0 3px;
  height: 21px;
  .customers-icon {
    path {
      fill: var(--text-primary);
    }
  }
`;
const Userprofile = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
  min-width: 280px;
  ${mobile_xl(css`
    padding: 6px 12px;
  `)}
`;
const Profile = styled.div`
  width: 28px;
  height: 28px;
  img {
    border-radius: var(--border-radius-full);
    object-fit: cover;
  }
`;

const ResponsiveNavbarIcon = styled.div`
  display: none;
  ${mobile_xl(css`
    display: flex;
  `)}
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;
const PaginationSection = styled.div`
  display: flex;
  gap: 30px;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  background-color: var(--background-secondary);
  ${mobile_xl(css`
    padding: 20px 0 75px;
    justify-content: space-between;
    gap: 20px;
  `)}
  ${mobile_xs(css`
    flex-direction: column;
  `)}
`;
const LeftDiv = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  ${mobile_xl(css`
    gap: 8px;
  `)}
`;

const RightDiv = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  ${mobile_xl(css`
    gap: 8px;
  `)}
`;
const Text = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
`;
const ArrowBtn = styled.div`
  width: 66px;
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-full);
  display: flex;
  ${mobile_xl(css`
    width: auto;
    background: unset;
    border: unset;
    gap: 4px;
  `)}
`;
const Left = styled.div`
  cursor: pointer;
  padding: 8px;
  border-right: 0.5px solid var(--border-primary);
  display: flex;
  .stroke-color {
    path {
      stroke: var(--text-secondary);
    }
  }
  ${mobile_xl(css`
    border: unset;
    padding: 6px;
    svg {
      width: 20px;
      height: 20px;
    }
  `)}
`;

const Right = styled.div`
  cursor: pointer;
  padding: 8px;
  display: flex;
  .stroke-color {
    transform: rotate(180deg);
    path {
      stroke: var(--text-secondary);
    }
  }
  ${mobile_xl(css`
    padding: 6px;
    svg {
      width: 20px;
      height: 20px;
    }
  `)}
`;
const ShowRow = styled.div`
  border-radius: var(--border-radius-full);
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  padding: 7px 7px 7px 11px;
  display: flex;
  gap: 18px;
  align-items: center;
  cursor: pointer;
  ${mobile_xl(css`
    padding: unset;
    border: unset;
    background-color: unset;
    gap: 4px;
  `)}
`;
const RowText = styled.div`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
`;
const Downarrow = styled.div`
  display: flex;
  .stroke-color {
    transform: rotate(270deg);
    path {
      stroke: var(--text-secondary);
    }
  }
  .arrow-open {
    transform: rotate(90deg);
  }
  ${mobile_xl(css`
    svg {
      width: 18px;
      height: 18px;
    }
  `)}
`;
export {
  Group,
  Container,
  HeaderBlock,
  Heading,
  Icon,
  Title,
  Content,
  TitleWrap,
  TableData,
  UserDetails,
  Username,
  UserDescription,
  UserMail,
  UserNumber,
  Modalhead,
  Headline,
  Empty,
  ProfileIcon,
  Userprofile,
  Profile,
  OptionMenu,
  ResponsiveNavbarIcon,
  HeaderLeft,
  PaginationSection,
  RightDiv,
  LeftDiv,
  Text,
  ArrowBtn,
  Left,
  Right,
  ShowRow,
  RowText,
  Downarrow
};
